import React from 'react';
import { toast } from '@cotera/client/app/components';
import { useWhoami } from '@cotera/client/app/stores/org';
import { useAuth } from '@workos-inc/authkit-react';
import { Button } from '../../ui/button';
import { useLinearBotInstallation } from '../use-linear-bot-installation';
import { ConnectedStatusCard } from '../credential-connection-cards';
import { triggerLinearBotInstall } from './linear-oauth-install-popout';
import type { CredentialStrategyViewProps } from './credential-strategy-view-props';

export const LinearOauthInstallStrategyView: React.FC<
  CredentialStrategyViewProps
> = ({ onSuccess }) => {
  const orgId = useWhoami((s) => s.org.id);
  const { user } = useAuth();
  const userId = user?.id;
  const { installed } = useLinearBotInstallation();

  if (installed) {
    return (
      <ConnectedStatusCard
        title="Connected to Linear"
        description="Coco is installed in your Linear workspace."
        variant="success"
        isActive={true}
      />
    );
  }

  return (
    <Button
      onClick={() => {
        if (userId === undefined || userId.length === 0) {
          toast.error('Unable to determine user ID for Linear authorization');
          return;
        }

        try {
          triggerLinearBotInstall({ orgId, userId }, onSuccess);
        } catch {
          toast.error('Failed to open Linear authorization popup');
        }
      }}
    >
      Connect to Linear
    </Button>
  );
};
